import { useState } from "react"
import '@splidejs/react-splide/css';
import {ExportIcon, PlaceholderImage} from "./Icons"  
// import { addTemplateToDb } from "../utils/giftcardControllers"
import { useTranslation } from "react-i18next";
import "../localisation/index"

export default function GiftCardTemplate({setSelectedImage, selectedImage}) {
  const {t} = useTranslation()
  const [importLoading, setImportLoading] = useState(false)

  const handleAddImage = () => {
    const fileInput = document.getElementById("product-file-picker");
    const file = fileInput.files[0];

    if (!file) {
      alert(t("createGiftcard.selectImage"));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const img = new Image();
      img.onload = async () => {
        if (img.width === 600 && img.height === 250) {
          setSelectedImage(reader.result);
        } else {
          alert(t("createGiftcard.invalidDimensions") + `(${img.width}x${img.height})`);
          fileInput.value = "";
        }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="main-template-container">
      <div className="giftcard-product-image">
        <div className="giftcard-product-image__container">
        <label htmlFor="product-file-picker" className={importLoading ? "disabled-label" : ""}>
          <ExportIcon /> {selectedImage ? 'Edit product image' : 'Add product image' }
        </label>
        <input 
          type="file" 
          id="product-file-picker"
          accept="image/*" 
          onChange={handleAddImage} 
          disabled={importLoading} 
        />
        </div>
      </div>

      <div className="main-image-container">
        { !selectedImage ? <PlaceholderImage /> : <img src={selectedImage} alt="" /> }
      </div>
    </div>
  )
}